

export default class {

    constructor() {

        this.apiToken = '$2y$10$Q8DXfG009VhLIFQ.jVOUc.PQP9veEMmsqkthzMdi8xIFTCRkf2AEm';
      
        //tmd
        this.baseURL = 'https://dev.cityneeds.ng/koko/v1/api/';
        this.imageURL = 'https://dev.cityneeds.ng/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';

        //prep-dev-tmd
        // this.baseURL = 'https://prep.dev.cityneeds.ng/koko/v1/api/';
        // this.imageURL = 'https://prep.dev.cityneeds.ng/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';

      //  local
        //  this.baseURL = 'http://localhost/cityneeds/dev/koko/v1/api/';
        //  this.imageURL = 'http://localhost/cityneeds/dev/koko/v1/api/server/x52rs6c/pr.im.ti.ny.8/';
 
        //paga-keys
        this.koUrl =  this.baseURL+'prx/';
        // this.paga_apiBaseUrl = this.koUrl+'https://www.mypaga.com/paga-webservices/agent-rest/';
        // this.paga_principal = 'DB2DF78C-FF4E-427A-A75D-A399664127F1';
        // this.paga_password = 'hX5%T6b=fdK4';
        // this.paga_apiKey = '2a298a0dfde64d70896e8ba54078919702117bf5e45d43b6844822a29bce6b5a1704f7c7c4854332a45ca08ac1e63b9dad37104366d640d79ba7cb9eea32532d';
        //---2023
        this.paga_apiBaseUrl = this.koUrl+'https://www.mypaga.com/paga-webservices/business-rest/secured/';
        this.paga_principal = 'FFEEF6C1-18C6-40C4-AD90-B9FED2CE9C9F';
        this.paga_password = 'tP8@uv%dQHguBXR';
        this.paga_apiKey = 'bb9363108ed947c4932b42cbd0068ff291133e0a5ee04ac3afb3f4e365fa0de7aec14f90a5cb463f95f41587390efc3a50f40ce0d2a74acb9784007a21a202c9';
       //---2023
        //./paga-keys
    }

    
    //------data services
    
    // Getting state data
    getStates(context) {
        return context.$http.get(this.baseURL+'states');
    }

    // Getting state name
    getStateName(context, id) {
        return context.$http.get(this.baseURL+'states/'+id, {
             headers: {
               'Api-Token': this.apiToken,
              }
        });
    }

     // Getting state name
    getCityName(context, id) {
        return context.$http.get(this.baseURL+'cities/name/'+id, {
             headers: {
               'Api-Token': this.apiToken,
              }
        });
    }

    // Getting city data of state
    getCities(context, id) {
        return context.$http.get(this.baseURL+'cities/'+id, {
             headers: {
               'Api-Token': this.apiToken,
              }
        });
    }

    //get user id
    getUserID(context, id) {
        return context.$http.post(this.baseURL+'auth/sessions/id',id);
    }

    // Get Data Item
    getDataItem(context, data, id) {
        return context.$http.post(this.baseURL + 'auth/data/'+id, data, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }
    
    //Upload Image
    uploadDataPhoto(context, data) {
        return context.$http.post(this.baseURL + '/uploads', data, {
             headers: {
               'Api-Token': this.apiToken,
               'Content-Type': 'multipart/form-data',
            }
        });
    }
    //-----user services

    // User registration
    regUser(context, data) {
        return context.$http.post(this.baseURL + 'users', data, {
             headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    // Loging in admin
    loginAdmin(context, data) {
        return context.$http.post(this.baseURL + 'admin/login', data, {
             headers: {
                'Api-Token': this.apiToken
            }
        });
    }
   
    //session guard
    sessionGuard(context, data) {
        return context.$http.post(this.baseURL + 'auth/sessions', data, {
             headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    // user verify email
    verifyEmail(context, data) {
        return context.$http.post(this.baseURL + 'auth/verify/email', data, {
             headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    // user forgot password
    forgotPassword(context, data) {
        return context.$http.post(this.baseURL + 'admin/auth/password/forgot', data, {
             headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    // user verify reset token
    verifyResetToken(context, token) {
        return context.$http.post(this.baseURL + 'admin/auth/verify/reset/token/'+token,  {
             headers: {
                'Api-Token': this.apiToken
            }
        });
    }

   // reset forgot password
   resetForgotPassword(context, data) {
    return context.$http.post(this.baseURL + 'admin/auth/password/forgot/reset', data, {
        headers: {
            'Api-Token': this.apiToken
        }
    });
}

// user reset password
resetPassword(context, data) {
    return context.$http.post(this.baseURL + 'admin/auth/password/reset', data, {
         headers: {
            'Api-Token': this.apiToken
        }
    });
}

// user reset email
resetEmail(context, data) {
    return context.$http.post(this.baseURL + 'admin/auth/email/reset', data, {
         headers: {
            'Api-Token': this.apiToken
        }
    });
}

    // Get user surveys using token
    getUsers(context, id) {
        return context.$http.get(this.baseURL + 'users', {
            headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    //get single user
    getUser(context, id) {
        return context.$http.get(this.baseURL+'users/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    // Edit User data
    editProfile(context, data, id) {
        return context.$http.put(this.baseURL + 'users/'+id, data, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }

     // Delete 
     deleteUsers(context, id) {
        return context.$http.delete(this.baseURL + 'users/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    // Edit User
    adminEditUsers(context, id, data) {
        return context.$http.put(this.baseURL + 'admin/users/'+id, data, {
            headers: {
               'Api-Token': this.apiToken
            }
        });
    }

  

    //----//------user services

    //----------business-services

    //get business categories
    getBusinessCategories(context) {
        return context.$http.get(this.baseURL+'businesscategories', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //add business category
    addBusinessCategory(context, data) {
        return context.$http.post(this.baseURL + 'businessescategories', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    editBusinessCategories(context,id,data) {
        return context.$http.put(this.baseURL+'businesscategories/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //get all  businesses
    getAllBusinesses(context, id) {
        return context.$http.get(this.baseURL+'businesses', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    
    //get all users businesses
    getBusinesses(context, id) {
        return context.$http.get(this.baseURL+'businesses/user/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //get single business
    getBusiness(context, id) {
        return context.$http.get(this.baseURL+'businesses/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //Add business
    addBusiness(context, data) {
        return context.$http.post(this.baseURL + 'businesses', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    // Edit Business
    editBusiness(context, id, data) {
        return context.$http.put(this.baseURL + 'businesses/'+id, data, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    // Delete Business
    deleteBusiness(context, id) {
        return context.$http.delete(this.baseURL + 'businesses/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    // Delete Business Admin
    adminDeleteBusiness(context, id) {
        return context.$http.delete(this.baseURL + 'admin/businesses/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    //Search Businesses
    searchBusinesses(context, data) {
        return context.$http.post(this.baseURL + 'businesses/search', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    // Citisave Businesses
    citisaveBusinesses(context, data) {
        return context.$http.post(this.baseURL + 'businesses/citisave', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    //-----//-----business-services

    //----------cnpro-services

    //get cnpro categories
    getCnproParentCategories(context) {
        return context.$http.get(this.baseURL+'cnprocategories/parent', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    editCnproParentCategories(context,id,data) {
        return context.$http.put(this.baseURL+'cnprocategories/parent/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //get cnpro categories
    getCnproCategories(context, id) {
        return context.$http.get(this.baseURL+'cnprocategories/sub/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    //get cnpro all sub categories
    getCnproSubCategories(context, id) {
        return context.$http.get(this.baseURL+'cnprocategories/sub', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    editCnproSubCategories(context,id,data) {
        return context.$http.put(this.baseURL+'cnprocategories/sub/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //add cnpro category
    addCnproParentCategory(context, data) {
        return context.$http.post(this.baseURL + 'cnprocategories', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    //add cnpro sub category
    addCnproSubCategory(context, data) {
        return context.$http.post(this.baseURL + 'cnprocategories/sub', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    //get all cnpros
    getAllCnpros(context) {
        return context.$http.get(this.baseURL+'/settings/cnpros', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //get all users cnproS
    getCnpros(context, id) {
        return context.$http.get(this.baseURL+'cnpros/user/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //get single cnpro
    getCnpro(context, id) {
        return context.$http.get(this.baseURL+'cnpros/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //Add cnpro
    addCnpro(context, data) {
        return context.$http.post(this.baseURL + 'cnpros', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    //Add cnpro
    addCnproPhoto(context, data) {
        return context.$http.post(this.baseURL + 'cnpros/uploads', data, {
             headers: {
               'Api-Token': this.apiToken,
               'Content-Type': 'multipart/form-data',
               
            }
        });
    }

    // Edit cnpro
    editCnpro(context, data, id) {
        return context.$http.put(this.baseURL + 'cnpros/'+id, data, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    // appeovecnpro
    approveCnpro(context, id, data) {
        return context.$http.put(this.baseURL + 'cnpros/approvals/'+id, data, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    // Delete cnpro
    deleteCnpro(context, id) {
        return context.$http.delete(this.baseURL + 'cnpros/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    // Delete Cnpro Admin
    adminDeleteCnpros(context, id) {
        return context.$http.delete(this.baseURL + 'admin/cnpros/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    // Edit CNpro
    adminEditCnpros(context, id, data) {
        return context.$http.put(this.baseURL + 'admin/cnpros/'+id, data, {
            headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    //Upload Image
    // uploadDataPhoto(context, data) {
    //     return context.$http.post(this.baseURL + '/uploads', data, {
    //          headers: {
    //            'Api-Token': this.apiToken,
    //            'Content-Type': 'multipart/form-data',
    //         }
    //     });
    // }

    //Search cnpro
    searchCnpros(context, data) {
        return context.$http.post(this.baseURL + 'cnpros/search', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    //-------//------cnpros-sevrices

    //----------------savedListings 
    //get all users contracts
    getSavedListings(context, id) {
        return context.$http.get(this.baseURL+'citisaves/users/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //get saved listing
    getSavedListing(context, id) {
        return context.$http.get(this.baseURL+'citisaves/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    // Save data
    saveListing(context, data) {
        return context.$http.post(this.baseURL + 'citisaves', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    //---------//------savedListings

    //--------contracts-services

    //get all contracts
    getContracts(context, id) {
        return context.$http.get(this.baseURL+'contracts', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //get all users contracts
    getUserContracts(context, id) {
        return context.$http.get(this.baseURL+'contracts/user/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //get all users contracts
    getCnproContracts(context, id) {
        return context.$http.get(this.baseURL+'contracts/cnpro/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //get  a contract
    getContract(context, id) {
        return context.$http.get(this.baseURL+'contracts/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    // Check Requested Quote
    checkCnproContractRequest(context, data) {
        return context.$http.post(this.baseURL + 'contracts/checks', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    // Request Quote
    requestQuote(context, data) {
        return context.$http.post(this.baseURL + 'contracts', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    // reply Quote
    replyQuote(context, id, data) {
        return context.$http.post(this.baseURL + 'contracts/reply', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    // set Quote
    setQuote(context, id, data) {
        return context.$http.put(this.baseURL + 'contracts/set/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
     // update Quote
    updateQuote(context, id, data) {
        return context.$http.put(this.baseURL + 'contracts/update/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    // accept Quote
    acceptQuote(context, id, data) {
        return context.$http.put(this.baseURL + 'contracts/accept/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
     // reject Quote
    rejectQuote(context, id, data) {
        return context.$http.put(this.baseURL + 'contracts/reject/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    // confirm Job by Cnpro
    confirmContractCnpro(context, id, data) {
        return context.$http.put(this.baseURL + 'contracts/confirm/cnpro/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    // confirm Quote
    confirmContract(context, id, data) {
        return context.$http.put(this.baseURL + 'contracts/confirm/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    // close Quote
    closeContract(context, id, data) {
        return context.$http.put(this.baseURL + 'contracts/close/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

     // end contract
     endContract(context, id, data) {
        return context.$http.put(this.baseURL + 'contracts/end/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    //-----//---contracts-services

    //-------------payments
    //  
    updatePayment(context, id, data) {
        return context.$http.put(this.baseURL + 'contracts/payments/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    //-----/.---payments-services
    //---complaints
    getContractComplaints(context, id) {
        return context.$http.get(this.baseURL+'contracts/complaints/'+id, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }
    makeComplaint(context, id, data) {
        return context.$http.post(this.baseURL + 'contracts/complaints', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    //--./complaints
    //------------reviews
    getAllReviews(context) {
        return context.$http.get(this.baseURL+'reviews', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    //submit reviews
    submitReview(context, data) {
        return context.$http.post(this.baseURL + 'reviews', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    //------//----reviews

    //------------rating
   
    //rating
    submitRating(context, data) {
        return context.$http.post(this.baseURL + 'ratings', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    //------//----ratings

    //------------forums
    //get all forums
    getAllForums(context) {
        return context.$http.get(this.baseURL+'forums', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //------//------forums

    //============== FORUMS & THREAD SERVICES ============//

    // Posting a thread
    postThread(context, data) {
        return context.$http.post(this.baseURL + 'forums', data, {
            headers: {
               'Api-Token': this.apiToken
           }
       });
    }

    // Getting user threads
    getUserThreads(context, id) {
        return context.$http.get(this.baseURL+'forums/users/'+id, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    // Getting one thread info
    getThread(context, id) {
        return context.$http.get(this.baseURL+'forums/'+id, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    //delete forum
    deleteForum(context, id) {
        return context.$http.delete(this.baseURL+'forums/'+id, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    //delete forum comment
    deleteForumComment(context, id) {
        return context.$http.delete(this.baseURL+'forums/comments/'+id, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    // Getting thread comments
    forumComments(context, id) {
        return context.$http.get(this.baseURL+'forums/comments/'+id, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    // Post comment to thread
    addThreadComment(context, data) {
        return context.$http.post(this.baseURL + 'forums/comments', data, {
            headers: {
               'Api-Token': this.apiToken
           }
        });
    }

    //============== SURVEY SERVICES ============//
    // Get all surveys
    getSurveys(context) {
        return context.$http.get(this.baseURL + 'settings/cnsurveys', {
            headers: {
               'Api-Token': this.apiToken
           }
        });
    }
    // Create survey
    survey(context, data) {
        return context.$http.post(this.baseURL + 'cnsurveys', data, {
            headers: {
               'Api-Token': this.apiToken
           }
        });
    }

    // Add Survey Question
    addSurveyQuestion(context, data) {
        return context.$http.post(this.baseURL + 'cnsurveys/questions', data, {
            headers: {
               'Api-Token': this.apiToken
           }
        });
    }

    // Edit Survey
    editSurvey(context, data, id) {
        return context.$http.put(this.baseURL + 'cnsurveys/'+id, data, {
            headers: {
               'Api-Token': this.apiToken
           }
        });
    }

    // Edit Survey
    editSurveyQuestion(context, data, id) {
        return context.$http.put(this.baseURL + 'cnsurveys/questions/'+id, data, {
            headers: {
               'Api-Token': this.apiToken
           }
        });
    }

    // Get user surveys
    userSurveys(context, id) {
        return context.$http.get(this.baseURL + 'cnsurveys/users/'+id, {
            headers: {
               'Api-Token': this.apiToken
           }
        });
    }

    // Get user surveys using token
    getUserSurveys(context, id) {
        return context.$http.get(this.baseURL + 'cnsurveys/users/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    // Get all surveys
    allSurveys(context) {
        return context.$http.get(this.baseURL + 'cnsurveys', {
            headers: {
               'Api-Token': this.apiToken
           }
        });
    }

    // Answer survey
    surveyAns(context, data) {
        return context.$http.post(this.baseURL + 'cnsurveys/answers', data, {
            headers: {
               'Api-Token': this.apiToken
           }
        });
    }

    // Delete Survey
    deleteSurvey(context, id) {
        return context.$http.delete(this.baseURL + 'cnsurveys/'+id, {
            headers: {
               'Api-Token': this.apiToken
           }
        });
    }

    // Delete Survey Questions
    deleteSurveyQuestion(context, id) {
        return context.$http.delete(this.baseURL + 'cnsurveys/questions/'+id, {
            headers: {
               'Api-Token': this.apiToken
           }
        });
    }

    
    // approve survey
    approveSurvey(context, id, data) {
        return context.$http.put(this.baseURL + 'cnsurveys/approvals/'+id, data, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    // approve survey
    setActivationFee(context, id, data) {
        return context.$http.put(this.baseURL + 'cnsurveys/activations/'+id, data, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }

    //payments
    //get all payments
    getPaymentPlans(context) {
        return context.$http.get(this.baseURL+'plans', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }


    //setpayment
    setPaymentPlan(context, data) {
        return context.$http.post(this.baseURL + 'plans/users', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    updatePaymentPlan(context, id, data) {
        return context.$http.put(this.baseURL + 'plans/payments/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    //payments and transactions
    getTransactions(context, id) {
        return context.$http.get(this.baseURL+'transactions', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //monies
    //get all monies
    getPayments(context, id) {
        return context.$http.get(this.baseURL+'monies', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    getMonies(context, id) {
        return context.$http.get(this.baseURL+'monies/users/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //get money
    getMoney(context, id) {
        return context.$http.get(this.baseURL+'monies/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //update monies
    updateMoniesPaid(context, id, data) {
        return context.$http.put(this.baseURL + 'monies/payments/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }

    //admin pay out
    updateMoniesPayOut(context, id, data) {
        return context.$http.put(this.baseURL + 'monies/payouts/'+id, data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    //---./monies


    //cnpay remita
    getCNpayments(context) {
        return context.$http.get(this.baseURL+'cnpayments', {
             headers: {
               'Api-Token': this.apiToken,
              }
        });
    }

    //paga
    getCNpaymentsPaga(context) {
        return context.$http.get(this.baseURL+'cnpayments/paga', {
             headers: {
               'Api-Token': this.apiToken,
              }
        });
    }

    getCNpayCharges(context, id) {
        return context.$http.get(this.baseURL+'cnpayments/cnpaycharges', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    getCNpayCommissions(context, id) {
        return context.$http.get(this.baseURL+'cnpayments/commissions', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    editCnpayCharges(context, id, data) {
        return context.$http.put(this.baseURL+'cnpayments/charges/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    editCnpayCommissions(context, id, data) {
        return context.$http.put(this.baseURL+'cnpayments/commissions/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    //...//.cnpay

    //...wallets
    getWalletProcessingCharges(context) {
        return context.$http.get(this.baseURL+'cnwallet/charges', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    addWalletProcessingCharge(context, data) {
        return context.$http.post(this.baseURL+'cnwallet/charges', data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    editWalletProcessingCharge(context, id, data) {
        return context.$http.put(this.baseURL+'cnwallet/charges/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    deleteWalletProcessingCharge(context, id) {
        return context.$http.delete(this.baseURL+'cnwallet/charges/'+id,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    getWalletTransactions(context) {
        return context.$http.get(this.baseURL+'cnwallet/admin/all/transactions', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    getUserWalletTransactions(context, id) {
        return context.$http.get(this.baseURL+'cnwallet/admin/user/transactions/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    postWalletTopup(context, data) {
        return context.$http.post(this.baseURL + 'cnwallet/transactions/topup', data, {
             headers: {
               'Api-Token': this.apiToken
            }
        });
    }
    //..//wallets

    ///...rewards
    getServiceRewards(context) {
        return context.$http.get(this.baseURL+'rewards/services', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    addServiceRewards(context, data) {
        return context.$http.post(this.baseURL+'rewards/services', data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    editServiceRewards(context, id, data) {
        return context.$http.put(this.baseURL+'rewards/services/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    deleteServiceRewards(context, id) {
        return context.$http.delete(this.baseURL+'rewards/services/'+id,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    getRewardsTransactions(context) {
        return context.$http.get(this.baseURL+'rewards/admin/all/transactions', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    //..//rewards
    //----/referral
    getUserReferralTransactions(context, id) {
        return context.$http.get(this.baseURL+'referrals/admin/user/transactions/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    getReferralsTransactions(context) {
        return context.$http.get(this.baseURL+'referrals/admin/all/transactions', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    //---./referrals

    //cndiscounts
    getCNdiscounts(context) {
        return context.$http.get(this.baseURL+'cndiscounts', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    //../cndiscounts

    //cninsurance
    getCNinsurance(context) {
        return context.$http.get(this.baseURL+'cninsurance/listings', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //cninsurance forms
    getCNinsuranceForms(context,id) {
        return context.$http.get(this.baseURL+'cninsurance/forms/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //cninsurance claims
    getCNinsuranceClaims(context,id) {
        return context.$http.get(this.baseURL+'cninsurance/claims/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    //cninsurance complaints
    getCNinsuranceComplaints(context,id) {
        return context.$http.get(this.baseURL+'cninsurance/complaints/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    //addCNinsuraceDiscount
    addCNinsuranceDiscount(context, data) {
        return context.$http.post(this.baseURL+'cninsurance/discounts', data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    //update cninsurance
    updateCNinsuranceDetails(context, id, data) {
        return context.$http.put(this.baseURL + 'cninsurance/'+id, data, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }
    //update cninsurance form price
    updateCNinsuraceFormPrice(context, id, data) {
        return context.$http.put(this.baseURL + 'cninsurance/prices/'+id, data, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }
    //update cninsurance cndiscount
    updateCNinsuranceDiscount(context, id, data) {
        return context.$http.put(this.baseURL + 'cninsurance/discounts/'+id, data, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }
    //../cninsurance

    //cndiscounts
    getCNdiscounts(context,offset,items) {
        return context.$http.get(this.baseURL+'cndiscounts/all/'+offset+'/'+items, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    // upday CNdiscount
    updateCNdiscount(context, id, data) {
        return context.$http.put(this.baseURL + 'cndiscounts/'+id, data, {
            headers: {
                'Api-Token': this.apiToken
            }
        });
    }
    //../cndiscounts

    //analytics
    getUserAnalytics(context, id) {
        return context.$http.get(this.baseURL+'analytics/users/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    //..../analytics

    //activities
    getActivities(context, id) {
        return context.$http.get(this.baseURL+'activities', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    //..../activities

    //settings
    getCNServices(context, id) {
        return context.$http.get(this.baseURL+'settings/cnservices', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    getServiceCharges(context, id) {
        return context.$http.get(this.baseURL+'settings/servicecharges', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    editServiceCharges(context, id, data) {
        return context.$http.put(this.baseURL+'settings/servicecharges/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    getDefaultCharges(context, id) {
        return context.$http.get(this.baseURL+'settings/defaultcharges', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    editDefaultCharges(context, id, data) {
        return context.$http.put(this.baseURL+'settings/defaultcharges/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //edit 
    editPlansAndPricing(context, id, data) {
        return context.$http.put(this.baseURL+'plans/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //------settings.....===//


    /*..paga-----*/
    //paga main calls
    //get paga merchants
    pagaGetMerchants(context) {
       // return context.$http.post(this.paga_apiBaseUrl+'unsecured/getMerchants',{
        return context.$http.post(this.paga_apiBaseUrl+'getMerchants',{
            headers: {
                'Content-Type': 'application/json',
                principal: this.paga_principal,
                Credentials: this.paga_password,
            }
        });
    }

    //GetMobileOperators
    pagaGetMobileOperators(context) {
        ///return context.$http.post(this.paga_apiBaseUrl+'unsecured/getMobileOperators',{
        return context.$http.post(this.paga_apiBaseUrl+'getMobileOperators',{
            headers: {
                'Content-Type': 'application/json',
                principal: this.paga_principal,
                Credentials: this.paga_password,
                Accept: 'application/json'
            }
        });
    }

        
    //get / send general paga request
    getPagaRequest(context,data,url,hash) {
        return context.$http.post(url, data,{
            headers: {
                'Content-Type': 'application/json',
                principal: this.paga_principal,
                credentials: this.paga_password,
                hash: hash,
                accept: 'application/json'
            }
        });
    }
    //paga main calls



    //post paga merchants to db
    postPagaMerchants(context, data) {
        return context.$http.post(this.baseURL+'cnpay/paga/merchants', data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //post paga mobile operators to db
    postPagaMobileOperators(context, data) {
        return context.$http.post(this.baseURL+'cnpay/paga/mobileoperators', data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    getPagaMerchants(context) {
        return context.$http.get(this.baseURL+'cnpay/paga/merchants', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    getPagaMobileOperators(context) {
        return context.$http.get(this.baseURL+'cnpay/paga/mobileoperators', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    getPagaServiceGroups(context) {
        return context.$http.get(this.baseURL+'cnpay/paga/servicegroups', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //add paga service group
    addPagaServiceGroups(context, data) {
        return context.$http.post(this.baseURL+'cnpay/paga/servicegroups', data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //add paga service group
    addPagaServiceGroupMerchants(context, data) {
        return context.$http.post(this.baseURL+'cnpay/paga/servicegroups/merchants', data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    editPagaServiceGroups(context, id, data) {
        return context.$http.put(this.baseURL+'cnpay/paga/servicegroups/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    deletePagaServiceGroups(context, id) {
        return context.$http.delete(this.baseURL+'cnpay/paga/servicegroups/'+id,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    editPagaServiceGroupMerchants(context, id, data) {
        return context.$http.put(this.baseURL+'cnpay/paga/servicegroups/merchants/'+id, data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    deletePagaServiceGroupMerchants(context, id) {
        return context.$http.delete(this.baseURL+'cnpay/paga/servicegroups/merchants/'+id,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    postPagaMerchantDoNotDisplayServices(context, data) {
        return context.$http.post(this.baseURL+'cnpay/paga/merchant/donotdisplayservices', data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    deletePagaMerchantDoNotDisplayServices(context, id, merchant) {
        return context.$http.delete(this.baseURL+'cnpay/paga/merchant/donotdisplayservices/'+id+'/'+merchant,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }


    // getRewardsTransactions(context) {
    //     return context.$http.get(this.baseURL+'rewards/admin/all/transactions', {
    //         headers: {
    //            'Api-Token': this.apiToken
    //         }
    //     })
    // }
    //..//rewards


    /*....paga.....*/

    //mesages
    getMessages(context) {
        return context.$http.get(this.baseURL+'systemmessages', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //post read messages
    readMessages(context) {
        return context.$http.get(this.baseURL+'readmessages', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    //subscriptions
    getSubscribers(context) {
        return context.$http.get(this.baseURL+'subscriptions/requests', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    
    //notifications
    getNotifications(context) {
        return context.$http.get(this.baseURL+'notifications', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    getAdminNotifications(context) {
        return context.$http.get(this.baseURL+'/admin/notifications', {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    
    postNotifications(context, data) {
        return context.$http.post(this.baseURL+'notifications/admin', data,{
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    pushNotifications(context, id) {
        return context.$http.get(this.baseURL+'notifications/admin/push/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }

    deleteNotifications(context, id) {
        return context.$http.get(this.baseURL+'notifications/delete/'+id, {
            headers: {
               'Api-Token': this.apiToken
            }
        })
    }
    /*
    * Secure Hash Algorithm (SHA512)
    * http://www.happycode.info/
    */

    SHA512(str) {
        function int64(msint_32, lsint_32) {
        this.highOrder = msint_32;
        this.lowOrder = lsint_32;
        }
    
        var H = [new int64(0x6a09e667, 0xf3bcc908), new int64(0xbb67ae85, 0x84caa73b),
        new int64(0x3c6ef372, 0xfe94f82b), new int64(0xa54ff53a, 0x5f1d36f1),
        new int64(0x510e527f, 0xade682d1), new int64(0x9b05688c, 0x2b3e6c1f),
        new int64(0x1f83d9ab, 0xfb41bd6b), new int64(0x5be0cd19, 0x137e2179)];
    
        var K = [new int64(0x428a2f98, 0xd728ae22), new int64(0x71374491, 0x23ef65cd),
        new int64(0xb5c0fbcf, 0xec4d3b2f), new int64(0xe9b5dba5, 0x8189dbbc),
        new int64(0x3956c25b, 0xf348b538), new int64(0x59f111f1, 0xb605d019),
        new int64(0x923f82a4, 0xaf194f9b), new int64(0xab1c5ed5, 0xda6d8118),
        new int64(0xd807aa98, 0xa3030242), new int64(0x12835b01, 0x45706fbe),
        new int64(0x243185be, 0x4ee4b28c), new int64(0x550c7dc3, 0xd5ffb4e2),
        new int64(0x72be5d74, 0xf27b896f), new int64(0x80deb1fe, 0x3b1696b1),
        new int64(0x9bdc06a7, 0x25c71235), new int64(0xc19bf174, 0xcf692694),
        new int64(0xe49b69c1, 0x9ef14ad2), new int64(0xefbe4786, 0x384f25e3),
        new int64(0x0fc19dc6, 0x8b8cd5b5), new int64(0x240ca1cc, 0x77ac9c65),
        new int64(0x2de92c6f, 0x592b0275), new int64(0x4a7484aa, 0x6ea6e483),
        new int64(0x5cb0a9dc, 0xbd41fbd4), new int64(0x76f988da, 0x831153b5),
        new int64(0x983e5152, 0xee66dfab), new int64(0xa831c66d, 0x2db43210),
        new int64(0xb00327c8, 0x98fb213f), new int64(0xbf597fc7, 0xbeef0ee4),
        new int64(0xc6e00bf3, 0x3da88fc2), new int64(0xd5a79147, 0x930aa725),
        new int64(0x06ca6351, 0xe003826f), new int64(0x14292967, 0x0a0e6e70),
        new int64(0x27b70a85, 0x46d22ffc), new int64(0x2e1b2138, 0x5c26c926),
        new int64(0x4d2c6dfc, 0x5ac42aed), new int64(0x53380d13, 0x9d95b3df),
        new int64(0x650a7354, 0x8baf63de), new int64(0x766a0abb, 0x3c77b2a8),
        new int64(0x81c2c92e, 0x47edaee6), new int64(0x92722c85, 0x1482353b),
        new int64(0xa2bfe8a1, 0x4cf10364), new int64(0xa81a664b, 0xbc423001),
        new int64(0xc24b8b70, 0xd0f89791), new int64(0xc76c51a3, 0x0654be30),
        new int64(0xd192e819, 0xd6ef5218), new int64(0xd6990624, 0x5565a910),
        new int64(0xf40e3585, 0x5771202a), new int64(0x106aa070, 0x32bbd1b8),
        new int64(0x19a4c116, 0xb8d2d0c8), new int64(0x1e376c08, 0x5141ab53),
        new int64(0x2748774c, 0xdf8eeb99), new int64(0x34b0bcb5, 0xe19b48a8),
        new int64(0x391c0cb3, 0xc5c95a63), new int64(0x4ed8aa4a, 0xe3418acb),
        new int64(0x5b9cca4f, 0x7763e373), new int64(0x682e6ff3, 0xd6b2b8a3),
        new int64(0x748f82ee, 0x5defb2fc), new int64(0x78a5636f, 0x43172f60),
        new int64(0x84c87814, 0xa1f0ab72), new int64(0x8cc70208, 0x1a6439ec),
        new int64(0x90befffa, 0x23631e28), new int64(0xa4506ceb, 0xde82bde9),
        new int64(0xbef9a3f7, 0xb2c67915), new int64(0xc67178f2, 0xe372532b),
        new int64(0xca273ece, 0xea26619c), new int64(0xd186b8c7, 0x21c0c207),
        new int64(0xeada7dd6, 0xcde0eb1e), new int64(0xf57d4f7f, 0xee6ed178),
        new int64(0x06f067aa, 0x72176fba), new int64(0x0a637dc5, 0xa2c898a6),
        new int64(0x113f9804, 0xbef90dae), new int64(0x1b710b35, 0x131c471b),
        new int64(0x28db77f5, 0x23047d84), new int64(0x32caab7b, 0x40c72493),
        new int64(0x3c9ebe0a, 0x15c9bebc), new int64(0x431d67c4, 0x9c100d4c),
        new int64(0x4cc5d4be, 0xcb3e42b6), new int64(0x597f299c, 0xfc657e2a),
        new int64(0x5fcb6fab, 0x3ad6faec), new int64(0x6c44198c, 0x4a475817)];
    
        var W = new Array(64);
        var a, b, c, d, e, f, g, h, i, j;
        var T1, T2;
        var charsize = 8;
    
        function utf8_encode(str) {
        return unescape(encodeURIComponent(str));
        }
    
        function str2binb(str) {
        var bin = [];
        var mask = (1 << charsize) - 1;
        var len = str.length * charsize;
    
        for (var i = 0; i < len; i += charsize) {
        bin[i >> 5] |= (str.charCodeAt(i / charsize) & mask) << (32 - charsize - (i % 32));
        }
    
        return bin;
        }
    
        function binb2hex(binarray) {
        var hex_tab = '0123456789abcdef';
        var str = '';
        var length = binarray.length * 4;
        var srcByte;
    
        for (var i = 0; i < length; i += 1) {
        srcByte = binarray[i >> 2] >> ((3 - (i % 4)) * 8);
        str += hex_tab.charAt((srcByte >> 4) & 0xF) + hex_tab.charAt(srcByte & 0xF);
        }
    
        return str;
        }
    
        function safe_add_2(x, y) {
        var lsw, msw, lowOrder, highOrder;
    
        lsw = (x.lowOrder & 0xFFFF) + (y.lowOrder & 0xFFFF);
        msw = (x.lowOrder >>> 16) + (y.lowOrder >>> 16) + (lsw >>> 16);
        lowOrder = ((msw & 0xFFFF) << 16) | (lsw & 0xFFFF);
    
        lsw = (x.highOrder & 0xFFFF) + (y.highOrder & 0xFFFF) + (msw >>> 16);
        msw = (x.highOrder >>> 16) + (y.highOrder >>> 16) + (lsw >>> 16);
        highOrder = ((msw & 0xFFFF) << 16) | (lsw & 0xFFFF);
    
        return new int64(highOrder, lowOrder);
        }
    
        function safe_add_4(a, b, c, d) {
        var lsw, msw, lowOrder, highOrder;
    
        lsw = (a.lowOrder & 0xFFFF) + (b.lowOrder & 0xFFFF) + (c.lowOrder & 0xFFFF) + (d.lowOrder & 0xFFFF);
        msw = (a.lowOrder >>> 16) + (b.lowOrder >>> 16) + (c.lowOrder >>> 16) + (d.lowOrder >>> 16) + (lsw >>> 16);
        lowOrder = ((msw & 0xFFFF) << 16) | (lsw & 0xFFFF);
    
        lsw = (a.highOrder & 0xFFFF) + (b.highOrder & 0xFFFF) + (c.highOrder & 0xFFFF) + (d.highOrder & 0xFFFF) + (msw >>> 16);
        msw = (a.highOrder >>> 16) + (b.highOrder >>> 16) + (c.highOrder >>> 16) + (d.highOrder >>> 16) + (lsw >>> 16);
        highOrder = ((msw & 0xFFFF) << 16) | (lsw & 0xFFFF);
    
        return new int64(highOrder, lowOrder);
        }
    
        function safe_add_5(a, b, c, d, e) {
        var lsw, msw, lowOrder, highOrder;
    
        lsw = (a.lowOrder & 0xFFFF) + (b.lowOrder & 0xFFFF) + (c.lowOrder & 0xFFFF) + (d.lowOrder & 0xFFFF) + (e.lowOrder & 0xFFFF);
        msw = (a.lowOrder >>> 16) + (b.lowOrder >>> 16) + (c.lowOrder >>> 16) + (d.lowOrder >>> 16) + (e.lowOrder >>> 16) + (lsw >>> 16);
        lowOrder = ((msw & 0xFFFF) << 16) | (lsw & 0xFFFF);
    
        lsw = (a.highOrder & 0xFFFF) + (b.highOrder & 0xFFFF) + (c.highOrder & 0xFFFF) + (d.highOrder & 0xFFFF) + (e.highOrder & 0xFFFF) + (msw >>> 16);
        msw = (a.highOrder >>> 16) + (b.highOrder >>> 16) + (c.highOrder >>> 16) + (d.highOrder >>> 16) + (e.highOrder >>> 16) + (lsw >>> 16);
        highOrder = ((msw & 0xFFFF) << 16) | (lsw & 0xFFFF);
    
        return new int64(highOrder, lowOrder);
        }
    
        function maj(x, y, z) {
        return new int64(
        (x.highOrder & y.highOrder) ^ (x.highOrder & z.highOrder) ^ (y.highOrder & z.highOrder),
        (x.lowOrder & y.lowOrder) ^ (x.lowOrder & z.lowOrder) ^ (y.lowOrder & z.lowOrder)
        );
        }
    
        function ch(x, y, z) {
        return new int64(
        (x.highOrder & y.highOrder) ^ (~x.highOrder & z.highOrder),
        (x.lowOrder & y.lowOrder) ^ (~x.lowOrder & z.lowOrder)
        );
        }
    
        function rotr(x, n) {
        if (n <= 32) {
        return new int64(
        (x.highOrder >>> n) | (x.lowOrder << (32 - n)),
        (x.lowOrder >>> n) | (x.highOrder << (32 - n))
        );
        } else {
        return new int64(
        (x.lowOrder >>> n) | (x.highOrder << (32 - n)),
        (x.highOrder >>> n) | (x.lowOrder << (32 - n))
        );
        }
        }
    
        function sigma0(x) {
        var rotr28 = rotr(x, 28);
        var rotr34 = rotr(x, 34);
        var rotr39 = rotr(x, 39);
    
        return new int64(
        rotr28.highOrder ^ rotr34.highOrder ^ rotr39.highOrder,
        rotr28.lowOrder ^ rotr34.lowOrder ^ rotr39.lowOrder
        );
        }
    
        function sigma1(x) {
        var rotr14 = rotr(x, 14);
        var rotr18 = rotr(x, 18);
        var rotr41 = rotr(x, 41);
    
        return new int64(
        rotr14.highOrder ^ rotr18.highOrder ^ rotr41.highOrder,
        rotr14.lowOrder ^ rotr18.lowOrder ^ rotr41.lowOrder
        );
        }
    
        function gamma0(x) {
        var rotr1 = rotr(x, 1), rotr8 = rotr(x, 8), shr7 = shr(x, 7);
    
        return new int64(
        rotr1.highOrder ^ rotr8.highOrder ^ shr7.highOrder,
        rotr1.lowOrder ^ rotr8.lowOrder ^ shr7.lowOrder
        );
        }
    
        function gamma1(x) {
        var rotr19 = rotr(x, 19);
        var rotr61 = rotr(x, 61);
        var shr6 = shr(x, 6);
    
        return new int64(
        rotr19.highOrder ^ rotr61.highOrder ^ shr6.highOrder,
        rotr19.lowOrder ^ rotr61.lowOrder ^ shr6.lowOrder
        );
        }
    
        function shr(x, n) {
        if (n <= 32) {
        return new int64(
        x.highOrder >>> n,
        x.lowOrder >>> n | (x.highOrder << (32 - n))
        );
        } else {
        return new int64(
        0,
        x.highOrder << (32 - n)
        );
        }
        }
    
        var str = utf8_encode(str);
        var strlen = str.length*charsize;
        var str = str2binb(str);
    
        str[strlen >> 5] |= 0x80 << (24 - strlen % 32);
        str[(((strlen + 128) >> 10) << 5) + 31] = strlen;
    
        for (var i = 0; i < str.length; i += 32) {
        a = H[0];
        b = H[1];
        c = H[2];
        d = H[3];
        e = H[4];
        f = H[5];
        g = H[6];
        h = H[7];
    
        for (var j = 0; j < 80; j++) {
        if (j < 16) {
        W[j] = new int64(str[j*2 + i], str[j*2 + i + 1]);
        } else {
        W[j] = safe_add_4(gamma1(W[j - 2]), W[j - 7], gamma0(W[j - 15]), W[j - 16]);
        }
    
        T1 = safe_add_5(h, sigma1(e), ch(e, f, g), K[j], W[j]);
        T2 = safe_add_2(sigma0(a), maj(a, b, c));
        h = g;
        g = f;
        f = e;
        e = safe_add_2(d, T1);
        d = c;
        c = b;
        b = a;
        a = safe_add_2(T1, T2);
        }
    
        H[0] = safe_add_2(a, H[0]);
        H[1] = safe_add_2(b, H[1]);
        H[2] = safe_add_2(c, H[2]);
        H[3] = safe_add_2(d, H[3]);
        H[4] = safe_add_2(e, H[4]);
        H[5] = safe_add_2(f, H[5]);
        H[6] = safe_add_2(g, H[6]);
        H[7] = safe_add_2(h, H[7]);
        }
    
        var binarray = [];
        for (var i = 0; i < H.length; i++) {
        binarray.push(H[i].highOrder);
        binarray.push(H[i].lowOrder);
        }
        return binb2hex(binarray);
    }

}


// WEBPACK FOOTER //
// ./src/services/service.js